import GoldPartners from "./GoldPartners";

export default GoldPartners;
